import * as React from 'react';
import {downloadFileFromURL, getFileMimeTypeFromURL} from '../../../../common/utils/GeneralUtils';
import {GROUP} from '../../../group/constants/LabelConstants';
import {
    CardCommissionAccountDetailsDispatchProps,
    CardCommissionAccountDetailsProps
} from '../../../group/types/mx/containers';
import {FILES_SECTION} from '../../../loan/common/constants/LabelConstants';
import ThumbnailFile from './thumbnail/ThumbnailFile';
import {LOAN_APPLICATION_MX} from '../../../constants/LabelConstants';

class CardCommissionAccountDetailView extends React.Component<CardCommissionAccountDetailsProps
    & CardCommissionAccountDetailsDispatchProps, {}> {

    onCancel = () => this.props.onCancel();

    onDelete = (commissionCardId: string) => this.props.onDelete(commissionCardId);

    onDownload = (item) => {
        const type: string = !!item.mimeType ? item.mimeType : getFileMimeTypeFromURL(item.url);
        return downloadFileFromURL(item.url, item.name, type);
    }

    onSelect = (file) => {
        window.open(file.url, '_blank');
    }

    render() {
        const {
            cardNumber,
            cardHolderName,
            commissionCardId,
            hideButtonDelete,
            actFile,
            identificationFile,
            identificationGroupFile,
            cardBackupCodeFile
        } = this.props;
        const btnStyle = 'btn btn-link btn-form border-0 h-100 pb-2';

        return (
            <div id="detailView" className="col-12 px-0 pt-5 pb-0">
                <div className="row pb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">
                                            {GROUP.GROUP_CARD_COMMISSION_ACCOUNT_NUMBER_FIELD_TITLE}
                                        </div>
                                        <div className="detail-information">
                                            {cardNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <div className="row mb-4">
                                    <div className="col">
                                        <div className="title-label">{GROUP.GROUP_BENEFICIARY_NAME_TITLE}</div>
                                        <div className="detail-information">
                                            {cardHolderName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pb-3">
                    {actFile && <div className="col">
                        <div className="title-label">{GROUP.GROUP_CREATE_CARD_COMMISSION_ACT_FILE_TITLE}</div>
                        <div className="detail-information w-100">
                            <ThumbnailFile
                                defaultClass="clickable-component"
                                showPDFBackground={true}
                                onClick={() => this.onSelect(actFile)}
                                file={actFile}/>
                        </div>
                        <div className="link-details mt-2" onClick={() =>
                            this.onDownload(actFile)}>
                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                        </div>
                    </div>}
                    {identificationFile && <div className="col">
                        <div className="title-label">
                            {GROUP.GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_FILE_TITLE}
                        </div>
                        <div className="detail-information w-100">
                            <ThumbnailFile
                                defaultClass="clickable-component"
                                showPDFBackground={true}
                                onClick={() => this.onSelect(identificationFile)}
                                file={identificationFile}/>
                        </div>
                        <div className="link-details mt-2" onClick={() =>
                            this.onDownload(identificationFile)}>
                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                        </div>
                    </div>}
                </div>
                <div className="row pb-2">
                    {identificationGroupFile && <div className="col">
                        <div className="title-label">
                            {GROUP.GROUP_CREATE_CARD_COMMISSION_IDENTIFICATION_GROUP_FILE_TITLE}
                        </div>
                        <div className="detail-information w-100">
                            <ThumbnailFile
                                defaultClass="clickable-component"
                                showPDFBackground={true}
                                onClick={() => this.onSelect(identificationGroupFile)}
                                file={identificationGroupFile}/>
                        </div>
                        <div className="link-details mt-2" onClick={() =>
                            this.onDownload(identificationGroupFile)}>
                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                        </div>
                    </div>}
                    {cardBackupCodeFile && <div className="col">
                        <div className="title-label">
                            {GROUP.GROUP_CREATE_CARD_COMMISSION_CARD_BACKUP_CODE_FILE_TITLE}
                        </div>
                        <div className="detail-information w-100">
                            <ThumbnailFile
                                defaultClass="clickable-component"
                                showPDFBackground={true}
                                onClick={() => this.onSelect(cardBackupCodeFile)}
                                file={cardBackupCodeFile}/>
                        </div>
                        <div className="link-details mt-2" onClick={() =>
                            this.onDownload(cardBackupCodeFile)}>
                            {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                        </div>
                    </div>}
                </div>
                <div className="row pt-3 px-0 border-top mt-4">
                    {!hideButtonDelete && <div className="col">
                        <div className="d-flex justify-content-start">
                            <a className={`${btnStyle} text-secondary-lighten-5`}
                               onClick={_ => this.onDelete(commissionCardId)}>{FILES_SECTION.DELETE_LABEL}</a>
                        </div>
                    </div>}
                    <div className="col">
                        <div className="d-flex justify-content-end">
                            <a className={`${btnStyle} text-secondary-lighten-5`}
                               onClick={this.onCancel}>{FILES_SECTION.CANCEL_LABEL}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardCommissionAccountDetailView;
